import {
    Component,
    OnInit,
    Input,
    HostBinding
} from '@angular/core';
import { PowerLevelPipe } from '../power-level.pipe';

@Component({
    selector: 'app-power-info',
    templateUrl: './power-info.component.pug',
    styleUrls: ['./power-info.component.less']
})
export class PowerInfoComponent implements OnInit {
    @Input() powerName;
    @Input() powerInfo;
    @Input() powerLevel;

    @HostBinding('attr.level') get level() {
        return this.powerLevel;
    }

    constructor() { }

    ngOnInit() {
    }

}
